import ListingChipsList from './ListingChipsList';

export default ListingChipsList;
